import Icon from "../icons/icon";
import { IconType } from "../icons/icon-props";

interface BlackButtonProps {
  id?: string;
  text?: string;
  icon?: IconType;
  onClick: Function;
  className?: string;
}

const BlackButton = ({
  id,
  text,
  icon,
  className,
  onClick,
}: BlackButtonProps) => {
  return (
    <button
      id={id}
      onClick={() => onClick()}
      className={`${className} flex items-center rounded-full bg-black text-white text-small py-2 px-5 truncate`}
    >
      {icon && <Icon icon={icon} className="mr-3 fill-white" />}
      {text && <p>{text}</p>}
    </button>
  );
};

export default BlackButton;
